import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import threadInfoFragment from '../../fragments/thread/threadInfo';

export const editThreadMutation = gql`
  mutation editThread($input: EditThreadInput!) {
    editThread(input: $input) {
      ...threadInfo
    }
  }
  ${threadInfoFragment}
`;

const editThreadOptions = {
  props: ({ mutate }) => ({
    editThread: input =>
      mutate({
        variables: {
          input,
        },
      }),
  }),
};

export default graphql(editThreadMutation, editThreadOptions);
